import React from 'react';
import {calculateBarSize} from '../calculateBarSize';
import stylesheet from './PictoGraph.module.scss';

import {useVotingResults} from '../common/useVotingResults';
import HumanGreen from './human_green.png';
import HumanRed from './human_red.png';
import QuestionHeader from '../../../common/QuestionHeader/QuestionHeader';
import Screen from '../../../../Screen';
import Result from './Result/Result';

const PictoGraph = props => {
    const {question, results} = props,
        options = props.options || question.options,
        [indexedResults, sum, max] = useVotingResults(results),
        header = <QuestionHeader {...props} />;

    return (
        <Screen className={'LiveVoting'} header={header}>
            <div className={stylesheet.PictoGraph}>
                {options.map((option, i) => (
                    <Result key={i} option={option} sum={sum} max={max} value={indexedResults[option.id]} pictogram={i ? HumanRed : HumanGreen} />
                ))}
            </div>
        </Screen>
    );
};

export default PictoGraph;
